import * as React from "react"

// @ts-ignore
import {  saUl, saItem, saItemText } from "./saList.module.scss"


interface item {
    text?: string
}


export const SaList: React.FC<item> = ({ ...props }) => {

  let items = Object.values(props).map((item, index) => (
      <li key={index} className={saItem}>
          {
            item.text &&
            <div className={saItemText}
                 dangerouslySetInnerHTML={{ __html: item.text }} />
          }
      </li>
    )
  )

  return (
    <ul className={'saDefaultUl ' + saUl}>
      { items }
    </ul>
  )
}